import {StaticImageData} from 'next/image';
import {cdnUrl} from '@/util/cdnImage';
import {colors} from '@/styles/tokens';
import clutchBadge from 'public/images/Blockchain-images/Clutch-Review-bagdes.webp';
import goodfirmsBadge from 'public/images/Blockchain-images/Goodfirms-Review-bagdes.webp';
import topDevBadge from 'public/images/Blockchain-images/Top-Developer-bagdes.webp';

export interface ReviewBadgeLink {
    key: string;
    href: string;
    src: StaticImageData;
    alt: string;
    hiddenLabel: string;
}

export const reviewBadgeLinks: readonly ReviewBadgeLink[] = [
    {
        key: 'clutch',
        href: 'https://clutch.co/profile/debut-infotech#reviews',
        src: clutchBadge,
        alt: 'Clutch Review Badge',
        hiddenLabel: 'Review us on Clutch - Debut Infotech'
    },
    {
        key: 'goodfirms',
        href: 'https://www.goodfirms.co/company/debut-infotech',
        src: goodfirmsBadge,
        alt: 'Goodfirms Review Badge',
        hiddenLabel: 'Review us on GoodFirms - Debut Infotech'
    },
    {
        key: 'topdevelopers',
        href: 'https://www.topdevelopers.co/profile/debut-infotech',
        src: topDevBadge,
        alt: 'Top Developer Badge',
        hiddenLabel: 'Top Blockchain Developer on TopDevelopers - Debut Infotech'
    }
] as const;

/**
 * Stacked badge cards — white wordmark on top, rating + stars, then the review
 * count — used by hero banners that render the score as crawlable text instead of
 * baking it into a single badge image. The logos share one 220x72 canvas, so the
 * intrinsic size is the same for all three and only the rendered height varies.
 */
export const reviewBadgeLogoIntrinsic = {width: 220, height: 72} as const;

export interface ReviewBadgeCard {
    key: string;
    logo: string;
    alt: string;
    logoHeight: number;
    href: string;
    srLabel: string;
    rating: number;
    note: string;
    /** Star colour — Clutch's stars are red, the rest gold. */
    starColor: string;
}

export const reviewBadgeCards: readonly ReviewBadgeCard[] = [
    {
        key: 'clutch',
        logo: cdnUrl('home-page-updated-assets/clutch-badge-logo.webp'),
        alt: 'Clutch',
        logoHeight: 40,
        href: 'https://clutch.co/profile/debut-infotech#reviews',
        srLabel: 'Read our reviews on Clutch',
        rating: 4.8,
        note: '42 Reviews',
        starColor: colors.accent.starRed
    },
    {
        key: 'goodfirms',
        logo: cdnUrl('home-page-updated-assets/goodfirms-badge-logo.webp'),
        alt: 'GoodFirms',
        logoHeight: 40,
        href: 'https://www.goodfirms.co/company/debut-infotech',
        srLabel: 'Read our reviews on GoodFirms',
        rating: 4.8,
        note: '37 Reviews',
        starColor: colors.accent.starYellow
    },
    {
        key: 'topdevelopers',
        logo: cdnUrl('home-page-updated-assets/topdev-badge-logo.webp'),
        alt: 'TopDevelopers',
        // The TopDevelopers wordmark carries more whitespace inside its canvas than the
        // other two, so it renders taller to read at the same visual size.
        logoHeight: 48,
        href: 'https://www.topdevelopers.co/profile/debut-infotech',
        srLabel: 'View our verified profile on TopDevelopers',
        rating: 4.9,
        note: 'Verified Profile',
        starColor: colors.accent.starYellow
    }
] as const;
